import { takeEvery, fork, put, all } from "redux-saga/effects"

// Login Redux States
import { LOGIN_USER, LOGOUT_USER } from "./actionTypes"
import { loginSuccess, apiError } from "./actions"

import ApiService from '../../../data/services/ApiService'
import activeCountries from '../../../data/activeCountries'

function* loginUser({ payload: { user, history } }) {
    try {
        const response = yield ApiService.login({
            email: user.email,
            password: user.password
        })

        if (!response.data.success) {
            yield put(apiError('invalid login'))
            return
        }

        window.analytics.identify(response.data.user.id, {
            email: response.data.user.email
        })

        // Si el país no está activado, mandamos a la vendora
        // a un landing de lista de espera
        if (!activeCountries.includes(response.data.user.countryCode)) {
            window.analytics.track('User Sent to Waiting List')
            history.push("/waiting-list")

            return
        }

        localStorage.setItem("authToken", response.data.token)
        localStorage.setItem("authUser", JSON.stringify(response.data.user))

        window.analytics.track('User Logged In')

        yield put(loginSuccess(response.data.user))

        history.push("/")
    } catch (error) {
        yield put(apiError(error))
    }
}

function* logoutUser({ payload: { history } }) {
    try {
        localStorage.removeItem("authToken")
        localStorage.removeItem("authUser")

        history.push("/login")
    } catch (error) {
        yield put(apiError(error))
    }
}

export function* watchUserLogin() {
    yield takeEvery(LOGIN_USER, loginUser)
}

export function* watchUserLogout() {
    yield takeEvery(LOGOUT_USER, logoutUser)
} 

function* authSaga() {
    yield all([fork(watchUserLogin), fork(watchUserLogout)])
}

export default authSaga
